// Copyright ©️ 2026 eVolve MEP, LLC

/**
 * Used primarily when you need to render `amount` number of components but don't have a source array.
 *
 * Example:
 *
 *     // Will render 5 dividers
 *     return (
 *       <>
 *         {mapAmount(5, (key) => <Divider key={key} />)}
 *       </>
 *     )
 */
export const mapAmount = <T>(amount: number, lambda: (key: string, index: number) => T, keyPrefix = 'mapped-key-') =>
  [...Array(Math.max(amount, 0))].map((_, i) => lambda(`${keyPrefix}${i}`, i));
